import React, { useState } from "react";
import { Nav, Navbar, Stack } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import {
  PersonCircleIcon,
  PersonIcon,
  cameraIcon,
  logoIcon,
} from "../../Utils/SVGs";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { i18n } from "../../Utils/translations";
import {
  BasicColor,
  ClinicColors,
  ContrastColor,
  ClinicsData,
} from "../../Utils/constants";
import InternetStatus from "./InternetStatus";
import { jsonParseFromLocalStorage } from "../../Funcs/Miscellaneous";

function HeaderStaff() {
  const { t, i18n } = useTranslation();
  document.body.dir = i18n.dir();
  const [showLoginModal, setshowLoginModal] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [expanded, setExpanded] = useState(true);
  const [currentClinic, setCurrentClinic] = useState(
    jsonParseFromLocalStorage("currentClinic", ClinicsData["Default"])
  );

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "ar" : "en";
    i18n.changeLanguage(newLang).then(() => {
      // do something after changing the language
      document.body.dir = i18n.dir();
    });
  };

  // useEffect(() => {
  //   setLoggedIn(CheckGoogleLoginStatus);
  //   console.log("useffectcalled", loggedIn);
  // }, []);

  // const CheckGoogleLoginStatus = async () => {
  //   const accessToken = localStorage.getItem("googleLoginAccessToken");
  //   const result = await LoginCheckGoogle(accessToken);
  //   console.log("result of login check", result);
  //   if (result) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  return (
    <Navbar
      expand="lg"
      expanded={expanded}
      style={{
        backgroundColor: currentClinic ? currentClinic.color : BasicColor,
      }}
      onClick={() => setExpanded(!expanded)}
    >
      <Navbar.Brand href={"/"}>
        {localStorage.getItem("isLogged") === "true" ? (
          logoIcon
        ) : (
          <img
            src={currentClinic.logo}
            width={160}
            height={100}
            style={{
              // marginRight: "20px",

              marginLeft: i18n.language === "en" ? "15px" : "0px",
              marginRight: i18n.language === "en" ? "5px" : "5px",
              borderRadius: "7px",
            }}
          ></img>
        )}
      </Navbar.Brand>
      <div
        style={{
          // margin: "20px",
          textAlign: i18n.language === "en" ? "left" : "right",
        }}
      >
        <Stack direction="horizontal" gap={1}>
          <InternetStatus />
          <div variant="outline-primary" onClick={toggleLanguage}>
            <span
              style={{
                paddingRight: "5px",
                paddingLeft: "5px",
                marginLeft: "10px",
                marginRight: "10px",
                color: "white",
                fontWeight: "bold",
                backgroundColor: "red",
              }}
            >
              {i18n.language === "en" ? "العربية" : "English"}
            </span>
          </div>
        </Stack>
      </div>
      {/* <Button
        variant=""
        onClick={() => {
          setshowLoginModal(true);
          console.log("showLoginModal", showLoginModal);
        }}
      >
        {loggedIn ? "In" : "Out"}
      </Button> */}

      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav fill variant="tabs">
          <Nav.Item>
            <NavLink className="nav-link" to="/" style={{ color: "white" }}>
              Home
            </NavLink>
          </Nav.Item>
          <Nav.Item>
            <NavLink
              className="nav-link"
              to="/upload"
              style={{ color: "white" }}
            >
              {cameraIcon("", 20)}
            </NavLink>
          </Nav.Item>

          <Nav.Item>
            <NavLink className="nav-link" to="/chat" style={{ color: "white" }}>
              Chat
            </NavLink>
          </Nav.Item>
          <Nav.Item>
            <NavLink
              className="nav-link"
              to="/admin"
              style={{ color: "white" }}
            >
              Admin
            </NavLink>
          </Nav.Item>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default HeaderStaff;
